import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator"

overrideIfMinBetNumberEnabled(function () {

    (function (responsiveLineType) {
        if (!responsiveLineType) { return; }

        var _createRowStake = responsiveLineType.createRowStake;
        $.extend(responsiveLineType, {
            createRowStake (selection, mode, context): string {
                return mode.toShowStakeBox(selection)
                        ? _createRowStake.apply(this, arguments)
                        : "";
            }
        });
    })(window.TResponsiveLineType);

});